import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { FilesViewerFile } from './../../../../../../libs/file-viewer/src/lib/core/model/file.model';
import { FormGroup } from '@angular/forms';
import { SharedService } from '../../services/shared.service';
import { TranslocoService } from '@ngneat/transloco';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'arsultima-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
})
export class UploadComponent implements OnInit, OnChanges {
  @Input()
  form: FormGroup;

  @Input()
  showRotate: boolean;

  @Input()
  loading: boolean;

  @Input()
  fileName: string;

  @Input()
  imageUrl: string;

  @Input()
  clickToZoomEnabled = true;

  @Input()
  buttonLabel: string;

  @Input()
  disabled = false;

  @Output()
  upload = new EventEmitter();

  @Output()
  delete = new EventEmitter();

  @Output()
  rotateImage = new EventEmitter();

  @Output()
  zoomImage = new EventEmitter<{ images: FilesViewerFile[] }>();

  @ViewChild('image')
  image: ElementRef;

  rotation = 0;
  numberOfRotation = 0;

  imageUrlWithRefresh: string;

  constructor(
    private readonly sharedService: SharedService,
    private translocoService: TranslocoService,
  ) {
    this.buttonLabel = this.translocoService.translate('buttons.uploadImage');
  }

  get fileInfo(): FilesViewerFile {
    return {
      src: this.imageUrl,
      title: this.fileName,
    };
  }

  ngOnInit(): void {}

  ngOnChanges({ imageUrl }: SimpleChanges): void {
    if (imageUrl && imageUrl.currentValue) {
      this.imageUrlWithRefresh = Utils.addRefreshParamToImage(imageUrl.currentValue);
    }
  }

  fileChange(files: FileList): void {
    this.form.markAsDirty();
    this.upload.emit(files);
  }

  clickZoomImage() {
    const payload = { images: [this.fileInfo] };
    if (this.clickToZoomEnabled) {
      this.sharedService.clickZoomImage(payload);
    }
    this.zoomImage.emit(payload);
  }

  deleteFile() {
    this.form.markAsDirty();
    this.delete.emit();
  }

  rotate() {
    this.rotation -= 90; // add 90 degrees, you can change this as you
    this.numberOfRotation++;
    if (this.rotation === -360) {
      // 360 means rotate back to 0
      this.rotation = 0;
      this.numberOfRotation = 0;
    }
    this.image.nativeElement.style.transform = `rotate(${this.rotation}deg`;
    this.form.markAsDirty();
    this.rotateImage.emit(this.numberOfRotation);
  }
}
